import GroupsComp, { ModalKeys } from "../../components/pages/groups";
import { useParams, useHistory, useLocation } from "react-router-dom";
export { ModalKeys } from "../../components/pages/groups";
function Groups() {
  const history = useHistory();
  const location = useLocation();
  let { modal, groupId, secondaryId } = useParams<any>();
  const resolveBase = () => {
    let base: string = location.pathname;
    if (modal) {
      base = base.replace(`/${modal}`, "");
    }
    if (groupId) {
      base = base.replace(`/${groupId}`, "");
    }
    if (secondaryId) {
      base = base.replace(`/${secondaryId}`, "");
    }

    if (base.endsWith("/")) {
      base = base.substr(0, base.length - 1);
    }
    return base;
  };
  const onShowModal = (key: ModalKeys, grpId?: string, secId?: string) => {
    let path: string[] = [resolveBase()];
    if (grpId) {
      path.push(grpId);
    }
    path.push(key);
    if (secId) {
      path.push(secId);
    }
    history.push(path.join("/"));
  };

  const onHideModal = (callback?: () => void) => {
    history.push(resolveBase());

    if (callback && typeof callback === "function") {
      callback();
    }
  };
  return (
    <GroupsComp
      showModal={{ key: modal as ModalKeys, groupId, secondaryId }}
      onShowModal={onShowModal}
      onHideModal={onHideModal}
    />
  );
}
export default Groups;
